import { Context } from '@embed/components/helpers';
import { EmbedFeedType, } from '@embed/hooks/useEmbedFeed';
export const mapParamsToConfiguration = (params, publisherClient, channel) => {
    var _a;
    const defaultValues = {
        firstVideoId: params.video,
        maxVideos: params.max_videos,
    };
    switch (true) {
        case !!params.app_id: {
            if (!publisherClient) {
                return null;
            }
            switch (publisherClient.feed_type) {
                case 'hashtag': {
                    const hashtag = (_a = publisherClient.config.hashtags) === null || _a === void 0 ? void 0 : _a[0];
                    return hashtag
                        ? {
                            embedFeedConfig: Object.assign(Object.assign({}, defaultValues), { type: EmbedFeedType.HASHTAG, hashtag }),
                            trackingData: {
                                context: Context.CONTEXT_HASHTAG,
                                hashtag: hashtag,
                                publisher_client_id: publisherClient.id,
                            },
                            trackingDataPixel: {
                                context: Context.CONTEXT_HASHTAG,
                                hashtag: hashtag,
                                _publisher_client_id: publisherClient.id,
                            },
                            context: Context.CONTEXT_HASHTAG,
                        }
                        : null;
                }
                case 'playlist': {
                    const playlist = publisherClient.config.playlist_id;
                    return playlist
                        ? {
                            embedFeedConfig: Object.assign(Object.assign({}, defaultValues), { type: EmbedFeedType.PLAYLIST, username: publisherClient.config.playlist_creator_username, playlistId: playlist }),
                            trackingData: {
                                context: Context.CONTEXT_PLAYLIST,
                                channel: publisherClient.config.playlist_creator_username,
                                channel_id: publisherClient.config.playlist_creator_id,
                                playlist_id: playlist,
                                publisher_client_id: publisherClient.id,
                            },
                            trackingDataPixel: {
                                context: Context.CONTEXT_PLAYLIST,
                                channel: publisherClient.config.playlist_creator_username,
                                _channel_id: publisherClient.config.playlist_creator_id,
                                _playlist_id: playlist,
                                _publisher_client_id: publisherClient.id,
                            },
                            context: Context.CONTEXT_PLAYLIST,
                        }
                        : null;
                }
                case 'users_videos':
                case 'recommendation': {
                    return {
                        embedFeedConfig: Object.assign(Object.assign({}, defaultValues), { type: EmbedFeedType.PUBLISHER_CLIENT, publisherClientId: publisherClient === null || publisherClient === void 0 ? void 0 : publisherClient.id }),
                        trackingData: {
                            context: Context.CONTEXT_DISCOVER,
                            publisher_client_id: publisherClient === null || publisherClient === void 0 ? void 0 : publisherClient.id,
                        },
                        trackingDataPixel: {
                            context: Context.CONTEXT_DISCOVER,
                            _publisher_client_id: publisherClient === null || publisherClient === void 0 ? void 0 : publisherClient.id,
                        },
                        context: Context.CONTEXT_DISCOVER,
                    };
                }
                case 'user_timeline': {
                    const { username, user_id } = publisherClient.config;
                    return username
                        ? {
                            embedFeedConfig: Object.assign(Object.assign({}, defaultValues), { type: EmbedFeedType.USER_TIMELINE, username }),
                            trackingData: {
                                context: Context.CONTEXT_CHANNEL,
                                channel: username,
                                channel_id: user_id,
                                publisher_client_id: publisherClient === null || publisherClient === void 0 ? void 0 : publisherClient.id,
                            },
                            trackingDataPixel: {
                                context: Context.CONTEXT_CHANNEL,
                                channel: username,
                                _channel_id: user_id,
                                _publisher_client_id: publisherClient.id,
                            },
                            context: Context.CONTEXT_CHANNEL,
                        }
                        : null;
                }
                default: {
                    return null;
                }
            }
        }
        case !!params.playlist: {
            return {
                embedFeedConfig: Object.assign(Object.assign({}, defaultValues), { type: EmbedFeedType.PLAYLIST, username: channel === null || channel === void 0 ? void 0 : channel.username, playlistId: params.playlist }),
                trackingData: {
                    context: Context.CONTEXT_PLAYLIST,
                    channel: channel === null || channel === void 0 ? void 0 : channel.username,
                    channel_id: channel === null || channel === void 0 ? void 0 : channel.encoded_id,
                    playlist_id: params.playlist,
                },
                trackingDataPixel: {
                    context: Context.CONTEXT_PLAYLIST,
                    channel: channel === null || channel === void 0 ? void 0 : channel.username,
                    _channel_id: channel === null || channel === void 0 ? void 0 : channel.encoded_id,
                    _playlist_id: params.playlist,
                },
                context: Context.CONTEXT_PLAYLIST,
            };
        }
        case !!params.playlist_collection: {
            return {
                embedFeedConfig: Object.assign(Object.assign({}, defaultValues), { type: EmbedFeedType.PLAYLIST_COLLECTION, username: channel === null || channel === void 0 ? void 0 : channel.username, playlistId: params.playlist }),
                trackingData: {
                    context: Context.CONTEXT_PLAYLIST_COLLECTION,
                    channel: channel === null || channel === void 0 ? void 0 : channel.username,
                    channel_id: channel === null || channel === void 0 ? void 0 : channel.encoded_id,
                    playlist_id: params.playlist,
                },
                trackingDataPixel: {
                    context: Context.CONTEXT_PLAYLIST_COLLECTION,
                    channel: channel === null || channel === void 0 ? void 0 : channel.username,
                    _channel_id: channel === null || channel === void 0 ? void 0 : channel.encoded_id,
                    _playlist_id: params.playlist,
                },
                context: Context.CONTEXT_PLAYLIST,
            };
        }
        case !!params.channel:
        case !!params.channel_id: {
            return {
                embedFeedConfig: params.hashtag
                    ? Object.assign(Object.assign({}, defaultValues), { type: EmbedFeedType.USER_TIMELINE_HASHTAG, username: channel === null || channel === void 0 ? void 0 : channel.username, hashtagExpression: params.hashtag || '' }) : Object.assign(Object.assign({}, defaultValues), { type: EmbedFeedType.USER_TIMELINE, username: channel === null || channel === void 0 ? void 0 : channel.username }),
                trackingData: {
                    context: Context.CONTEXT_CHANNEL,
                    channel: channel === null || channel === void 0 ? void 0 : channel.username,
                    channel_id: channel === null || channel === void 0 ? void 0 : channel.encoded_id,
                },
                trackingDataPixel: {
                    context: Context.CONTEXT_CHANNEL,
                    channel: channel === null || channel === void 0 ? void 0 : channel.username,
                    _channel_id: channel === null || channel === void 0 ? void 0 : channel.encoded_id,
                },
                context: Context.CONTEXT_CHANNEL,
            };
        }
        case !!params.hashtag: {
            return {
                embedFeedConfig: Object.assign(Object.assign({}, defaultValues), { type: EmbedFeedType.HASHTAG, hashtag: params.hashtag }),
                trackingData: {
                    context: Context.CONTEXT_HASHTAG,
                    hashtag: params.hashtag,
                },
                trackingDataPixel: {
                    context: Context.CONTEXT_HASHTAG,
                    hashtag: params.hashtag,
                },
                context: Context.CONTEXT_HASHTAG,
            };
        }
        case !!params.video: {
            //old version of storyblock has only video attr
            return {
                embedFeedConfig: Object.assign(Object.assign({}, defaultValues), { type: EmbedFeedType.USER_TIMELINE, username: 'firework' }),
                trackingData: {
                    context: Context.CONTEXT_CHANNEL,
                    channel: 'firework',
                },
                trackingDataPixel: {
                    context: Context.CONTEXT_CHANNEL,
                    channel: 'firework',
                },
                context: Context.CONTEXT_VIDEO_DETAIL,
            };
        }
        default: {
            return null;
        }
    }
};
